export default function v2ResourceDisplayName(v2ResourceName = '') {
  const [displayName] = `${v2ResourceName}`.split('/').reverse();
  return displayName || v2ResourceName;
}
